//网络请求接口
import axios from 'axios';
import Vue from 'vue'
import utils from './utils.js';
import interfaceToast from '@/i18n/interfaceToast-zh-CN';

export let request = {
  instance: undefined,
  instanceFile: undefined,
  url: {
    common: {
      getAreaList: '/system/area/child/'
    },
    login: {
      login: "/auth/userLogin",
      logout: "/auth/logout",
      updatePwd: "/system/user/profile/updatePwd",
      getTenantInfo: "/system/tenant/info"
    },
    personnel: {
      getUserInfo: "/user/getUserInfo",
      getUserListByPage: "/system/user/page",
    },
    scale: {
      getScaleInfoByTestId: "/client/user/action/test/scaleInfo/",
      getJumpRule: "/client/user/action/test/jumpRuleInfo/"
    },
    evalutaion: {
      getEvalutaionListByPage: "/client/user/action/test/page",
      getScaleListByTestId: "/client/user/action/test/scale/list/",
      getTestRecordInfo: "/client/user/action/test/record/info/",
      testStart: "/client/user/action/test/start/",
      testCommit: "/client/user/action/test/commit",
      getEvalutaionInfoById: "/client/test/"
    },
    report: {
      getReportListByPage: "/client/user/action/test/report/page",
      getUserReportInfo: "/client/user/action/test/info/",
      getReportState: "/client/user/action/test/testStatus/"
    },
    airTank: {
      deviceBindUser: "socket/device/bindUser"
    },
    aiChat: {
      sendMsg: '/ai/ai/v1/completions/history/stream',
      autovoice: '/ai/v2/chat/history/stream/voice',
      getChatList: '/ai/aiChatSession/page', //获取会话列表
      getChatDetailList: '/ai/aiChatHistory/page', //获取聊天记录
      getSessionId: '/ai/aiChatSession/add', //新增会话时获取SessionId
      delete: "/ai/aiChatSession/delete"
    },
    course: {
      getCourseList: "/client/course/page",
      getCourseCategory: "/client/courseCategory/page",
      getCourseDetails: "/client/course/info/",
      userCourseRecord: "/client/userCourseRecord/"
    },
    notification: {
      getUnreadCount: "/client/msgNotification/user/unreadCount",
      getListByPage: "/client/msgNotification/user/page",
      getDetailsById: "/client/msgNotification/",
      read: "/client/msgNotification/{id}/user/read"
    },
    information: {
      getToppingList: "/client/news/top",
      getListByPage: "/client/news/page",
      getDetailsById: "/client/news/"
    },
    psychologicalHotline: {
      getPsychologicalHotlineList: '/client/hotline/page'
    },
    event: {
      getEventList: '/client/activity/all/page',
      singUp: '/client/activity/user/singUp/',
      unSingUp: '/client/activity/user/cancel/',
      getEventDetail: '/client/activity/info/',
      getMyEventList: '/client/activity/my/page',
    }
  },
  create(instance) {
    let that = this;
    // 添加请求拦截器
    instance.interceptors.request.use(function(config) {
      // 添加语言
      config.headers["Global-Language"] = localStorage.getItem("language");
      if (utils.isLogin()) {
        var userInfo = utils.getUserInfo();
        if (!config.headers.tenantId) {
          config.headers.tenantId = userInfo.tenantId;
        }
        if (!config.headers.Authorization) {
          config.headers.Authorization = "Bearer " + userInfo.token;
        }
      }
      return config;
    }, function(error) {
      return Promise.reject(error);
    });
    // 添加响应拦截器
    instance.interceptors.response.use(function(response) {
      return response;
    }, function(error) {
      return Promise.reject(error);
    });
  },
  //初始化
  init: function() {
    this.instance = axios.create({
      baseURL: window.baseURL,
      timeout: 300000,
    });
    this.create(this.instance);
    this.instanceFile = axios.create({
      baseURL: window.baseURL,
      timeout: 600000,
    });
    this.create(this.instanceFile);
  },
  get: function(params, cb) {
    var headers = params.headers;
    if (!headers) {
      headers = {
        'Content-Type': 'application/json;charset=UTF-8'
      };
    } else {
      headers['Content-Type'] = "application/json;charset=UTF-8";
    }
    this.instance.get(params.url, {
      params: params.data,
      headers: headers
    }).then(function(response) {
      if (cb) {
        isCorrect(response.data, cb, params);
      }
    }).catch(function(error) {
      if (error.response && error.response.data) {
        errorHandle(error.response.data, cb, params);
      } else {
        errorHandle(error, cb, params);
      }
    });
  },
  delete: function(params, cb) {
    var headers = params.headers;
    if (!headers) {
      headers = {
        'Content-Type': 'application/json;charset=UTF-8'
      };
    } else {
      headers['Content-Type'] = "application/json;charset=UTF-8";
    }
    this.instance.delete(params.url, {
      params: params.data,
      headers: headers
    }).then(function(response) {
      if (cb) {
        isCorrect(response.data, cb, params);
      }
    }).catch(function(error) {
      if (error.response && error.response.data) {
        errorHandle(error.response.data, cb, params);
      } else {
        errorHandle(error, cb, params);
      }
    });
  },
  initPost: function(obj) {
    var query = '',
      name, value, fullSubName, subName, subValue, innerObj, i;
    for (name in obj) {
      value = obj[name];
      if (value instanceof Array) {
        for (i = 0; i < value.length; ++i) {
          subValue = value[i];
          fullSubName = name + '[' + i + ']';
          innerObj = {};
          innerObj[fullSubName] = subValue;
          query += this.initPost(innerObj) + '&';
        }
      } else if (value instanceof Object) {
        for (subName in value) {
          subValue = value[subName];
          fullSubName = name + '[' + subName + ']';
          innerObj = {};
          innerObj[fullSubName] = subValue;
          query += this.initPost(innerObj) + '&';
        }
      } else if (value !== undefined && value !== null)
        query += encodeURIComponent(name) + '=' + encodeURIComponent(value) + '&';
    }
    return query.length ? query.substr(0, query.length - 1) : query;
  },
  /**
   * post请求
   * @param {Object} params 参数
   * @param {Object} cb 回调函数
   */
  post: function(params, cb) {
    var headers = params.headers;
    if (!headers) {
      headers = {
        'Content-Type': 'application/json;charset=UTF-8'
      };
    } else {
      headers['Content-Type'] = "application/json;charset=UTF-8";
    }
    this.instance.post(params.url, params.data, {
      headers: headers,
      responseType: params.responseType ? params.responseType : 'json'
    }).then(function(response) {
      if (cb) {
        if (params.responseType == "blob") {
          cb(0, response.data);
        } else {
          isCorrect(response.data, cb, params);
        }
      }
    }).catch(function(error) {
      if (error.response && error.response.data) {
        errorHandle(error.response.data, cb, params);
      } else {
        errorHandle(error, cb, params);
      }
    });
  },
  /**
   * put请求
   * @param {Object} params 参数
   * @param {Object} cb 回调函数
   */
  put: function(params, cb) {
    var headers = params.headers;
    if (!headers) {
      headers = {
        'Content-Type': 'application/json;charset=UTF-8'
      };
    } else {
      headers['Content-Type'] = "application/json;charset=UTF-8";
    }
    this.instance.put(params.url, params.data, {
      headers: headers,
      responseType: params.responseType ? params.responseType : 'json'
    }).then(function(response) {
      if (cb) {
        if (params.responseType == "blob") {
          cb(0, response.data);
        } else {
          isCorrect(response.data, cb, params);
        }
      }
    }).catch(function(error) {
      if (error.response && error.response.data) {
        errorHandle(error.response.data, cb, params);
      } else {
        errorHandle(error, cb, params);
      }
    });
  },
  postFile: function(params, cb, baseUrl) {
    var config = {
      headers: {
        'Content-Type': 'multipart/form-data; charset=UTF-8'
      }
    }
    var url = params.url;
    if (params.baseURL) {
      url = params.baseURL + url;
    } else {
      url = window.baseFileURL + params.url;
    }
    this.instanceFile.post(url, params.file,
        config)
      .then(function(response) {
        if (cb) {
          isCorrect(response.data, cb, params)
        }
      })
      .catch(function(error) {
        if (params.doNotProcessResults) return;
        if (error.response && error.response.data) {
          errorHandle(error.response.data, cb, params);
        } else {
          errorHandle(error, cb, params);
        }
      });
  },
  /**
   * post请求
   * @param {Object} params 参数
   * @param {Object} cb 回调函数
   */
  postForm: function(params, cb) {
    var headers = params.headers;
    if (!headers) {
      headers = {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      };
    } else {
      headers['Content-Type'] = "application/x-www-form-urlencoded; charset=UTF-8";
    }
    var config = {
      headers: headers,
    }
    this.instance.post(params.url, this.initPost(params.data), config)
      .then(function(response) {
        if (cb) {
          isCorrect(response.data, cb, params)
        }
      }).catch(function(error) {
        if (params.doNotProcessResults) return;
        if (error.response && error.response.data) {
          errorHandle(error.response.data, cb, params);
        } else {
          errorHandle(error, cb, params);
        }
      });
  }
}

/**
 * 判断接口是否访问成功
 */
let isCorrect = function(result, cb, params) {
  if (result.code && result.code == 200) {
    cb(0, result)
  } else {
    cb(1, result)
    errorHandle(result, cb, params);
  }
};
let errorHandle = function(result, cb, params) {
  console.log(result)
  cb(1, result);
  if (result && result.code) {
    if (result.code == 401) { //token过期
      const expirationTime = sessionStorage.getItem('expirationTime');
      const currentTime = new Date().getTime();
      if(currentTime - expirationTime > 5000) {
        Vue.prototype.$toast(Vue.prototype.bus.$t("interfaceToast.loginTimeout"));
        utils.exitLogin(Vue.prototype.bus.$router, true);
        sessionStorage.setItem('expirationTime', currentTime);
      }
    } else if (interfaceToast[result.code]) {
      showErrorToast(Vue.prototype.bus.$t("interfaceToast." + result.code));
    } else if (result.msg) {
      showErrorToast(result.msg);
    } else {
      var text = Vue.prototype.bus.$t('interfaceToast.interfaceError');
      showErrorToast(text.replace('&&', result.code));
    }
  } else {
    showErrorToast(Vue.prototype.bus.$t('interfaceToast.networkError'));
  }
}
var showErrorToast = function(message) {
  if (message) {
    Vue.prototype.$toast(message);
  }
};


// WEBPACK FOOTER //
// ./src/utils/httpRequest.js